module.exports = __webpack_public_path__ + "static/media/4.6.b0fb37e6.png";